import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useFormik, FormikContext } from "formik";
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { setPostPinsale } from '../../../store/requestApi/thunk/pinsale/thunk/setPostPinsale';
// import { setPostResultDenomination } from '../../store/thunk/setPostResultDenomination';
// import { setPostIssueFrespin } from '../../store/thunk/setPostIssueFreespin';


const useStyles = makeStyles(() => ({
    flex: {
        display: 'flex'
    },
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'visible',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'visible',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '32%',
    }
}))

const CreatePinsale = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const initialValues = {
        game_uuid: '',
        bonus: '',
        value: 0,
        pinsale: '',
        count: 0,
    }

    const getValidation = (values) => {
        const { game_uuid, bonus, value, pinsale, count } = values;
        if (!game_uuid || !bonus || !value || !pinsale || !count) {
            return false;
        }
        return true;
    }

    const onSubmit = (store) => {
        dispatch(setPostPinsale(store)); 
    }
    

    const formik = useFormik({ onSubmit, initialValues });
    
    return (
        <div style={{ padding: '0 20px' }}>
            <Title label="Создание Pinsale" />
            <div style={{
                padding: '20px',
                background: '#1b2039',
                alignItems: 'center',
                borderRadius: '8px',
            }}>
                <FormikContext.Provider value={formik}>
                    <form
                        onSubmit={formik.handleSubmit}
                    >
                        <div className={classes.flex}>
                        <label htmlFor="select" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Тип Бонуса</span>
                                <select style={{height: '34px'}}
                                    className={classes.text}
                                    value={formik.values.bonus}
                                    onChange={(v) => formik.setFieldValue('bonus', v.target.value)}
                                >
                                    <option value="" style={{ display: 'none' }}>Выбрать Тип</option>
                                    <option value="fs">Freespin</option>
                                    <option value="cash">Бонусные деньги</option>
                                </select>
                            </label>
                        </div>
                        <div style={{ display: 'flex', columnGap: 12 }}>
                            <label htmlFor="count" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Количество активаций Pinsale</span>
                                <input
                                    type="number"
                                    name="count"
                                    id="count"
                                    className={classes.text}
                                    value={formik.values.count}
                                    onChange={(v) => formik.setFieldValue('count', v.target.value)} />
                            </label>
                            <label htmlFor="value" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Количество бонуса</span>
                                <input
                                    type="number"
                                    name="value"
                                    id="value"
                                    className={classes.text}
                                    value={formik.values.value}
                                    onChange={(v) => formik.setFieldValue('value', v.target.value)} />
                            </label>
                            <label htmlFor="game_uuid" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Игра</span>
                                <input
                                    type="text"
                                    name="game_uuid"
                                    id="game_uuid"
                                    className={classes.text}
                                    value={formik.values.game_uuid}
                                    onChange={(v) => formik.setFieldValue('game_uuid', v.target.value)} />
                            </label>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            columnGap: 12
                        }}>
                            <label htmlFor="pinsale" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Pinsale</span>
                                <input
                                    type="text"
                                    name="pinsale"
                                    id="pinsale"
                                    className={classes.text}
                                    value={formik.values.pinsale}
                                    onChange={(v) => formik.setFieldValue('pinsale', v.target.value)} />
                            </label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{
                                color: getValidation(formik.values) ? 'rgb(36, 38, 62)' : 'rgb(55, 136, 250)',
                                border: getValidation(formik.values) ? '1px solid rgb(255, 206, 1)' : '1px solid rgb(55, 136, 250)',
                                background: getValidation(formik.values) ? 'rgb(255, 206, 1)' : 'none',
                                cursor: getValidation(formik.values) ? 'pointer' : 'default',
                                padding: '5px 10px',
                                marginTop: formik.values.currency ? '8px' : '23px',
                                overflow: 'hidden',
                                fontSize: '14px',
                                maxHeight: '48px',
                                fontFamily: 'PT Sans, sans-serif',
                                fontWeight: 400,
                                userSelect: 'none',
                                whiteSpace: 'nowrap',
                                marginRight: '12px',
                                borderRadius: '16px',
                                textOverflow: 'ellipsis',
                                textTransform: 'uppercase',
                            }}
                            onClick={() => {
                                if (getValidation(formik.values)) {
                                    formik.submitForm()
                                }
                            }}
                            >Создать Pinsale</span>
                        </div>
                    </form>
                </FormikContext.Provider>
            </div>
        </div>
    )
}
export default CreatePinsale;
